module.exports = __webpack_public_path__ + "img/reception2.34ac17bd.png";